export const TEXT_ITEMS_CHARACTER_LENGTH_MAP = {
    secondary: 88,
    tertiary: 88,
};
